import { define, ui } from '@owenscorning/pcb.alpha';
import _ from 'lodash';

import { stringsFor } from '../../../../../location/locales';
import AlertMessage from '../../Page/AlertMessage';

export default define`Discontinued Banner`('0.0.1')({
  thumbnail: ui`Modules/Page/Thumbnails/AlertMessage`,
  view: ({ value }) => {
    const locale = Board.build.language.toLocaleLowerCase();
    const productType = Board.build.type;
    const productUrls = {
      'Product::Roofing': `/${locale}/roofing/components/products`,
      'Product::Insulation': `/${locale}/insulation/products`,
      'Product::Shingle': `/${locale}/roofing/shingles`,
      'Product::Enclosure': `/${locale}/insulation/commercial/enclosure/types`,
      'Product::Paroc': `/${locale}/products`,
    };

    const props = _.merge({}, value, {
      dismissable: false,
      message: {
        ops: [
          {
            insert: `${_.get(
              stringsFor(Board.build.language),
              'pdp.discontinued'
            )} `,
          },
          {
            attributes: { bold: true, link: productUrls[productType] },
            insert: _.get(stringsFor(Board.build.language), 'pdp.browse'),
          },
        ],
      },
      type: 'black',
    });
    return <AlertMessage.modes.view value={props} />;
  },
});
